/**
 * Company: SPHMedia
 * Description: This is the base page component for eShop related pages
 */

import CASBlock from "@components/Blocks/CASBlock/CASBlock";
import { MainContainerNew } from "@components/Blocks/Container/MainContainerNew";
import { FirebaseNotificationPrompt } from "@components/Blocks/FirebaseNotificationPrompt/FirebaseNotificationPrompt";
import FooterNewV2 from "@components/Modules/FooterNew/FooterNewV2";
import { HeaderNewV2 } from "@components/Modules/HeaderNew/HeaderNewV2";
import { CAS_EI_MODEL_ID, IS_PLAYWRIGHT_TEST } from "@helper/getEnvVariables";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";

export type BHSubscriptionPageProps = {
  children: React.ReactNode;
  bodyWrapperStyle?: string;
};

/**
 * BHSubscriptionPage
 * Description: The subscription page component for BH pages.
 * [Figma design](https://figma.com/design/3gGf0xQ9ZB6yM6dGm1J4Lk/BH-Subscription-Page?node-id=1-1)
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function BHSubscriptionPage({
  children,
  bodyWrapperStyle = "!my-0 lg:!my-0",
}: BHSubscriptionPageProps): ReactElement {
  return (
    <>
      <MainContainerNew>
        <HeaderNewV2 isEshopPage={true} />
        <div className={twMerge("my-3 lg:my-md w-full", bodyWrapperStyle)}>
          {IS_PLAYWRIGHT_TEST !== "true" && (
            <>
              <FirebaseNotificationPrompt />
            </>
          )}
          {children}
        </div>
      </MainContainerNew>
      <FooterNewV2 />
      <CASBlock casId={CAS_EI_MODEL_ID} />
    </>
  );
}
